import React, { useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import Template from './template';
import { ServiceApproveReject } from 'components';
import { apiServiceApproveChecked, apiGetDocRejectInfo } from 'api/ZimssaAPI';
import { useServiceStatus, useApiRequest } from 'hooks';
import { SERVICE_SELECT, PROFILE_REGISTER, SERVICE_FEATURE_REGISTER, USER_LIST, USER_REGISTER } from 'router/PageUrl';
import { getDocRejectComment } from 'commons/ZimssaHelper';

function ServiceApproveRejectView(): React.ReactElement {
    const history = useHistory();
    const { serviceIdx, serviceType, serviceDocStatus, serviceState } = useServiceStatus();
    const { isProfile, isMember, isOffer } = serviceState;

    const [fetchResult, fetchRejectInfo] = useApiRequest<any>(apiGetDocRejectInfo);
    const [rjectInfo, setRjectInfo] = useState<{
        documentDenialComment: string;
        rejectList: Array<string>;
        memberValid: boolean;
        profileImageValid: boolean;
    }>({ documentDenialComment: '', rejectList: [], memberValid: true, profileImageValid: true });

    useEffect(() => {
        if (serviceIdx && serviceType) {
            fetchRejectInfo({
                type: 'REQUEST',
                body: [serviceIdx, serviceType],
            });
        }
    }, [fetchRejectInfo, serviceIdx, serviceType]);

    useEffect(() => {
        const { result, data, message } = fetchResult;
        if (result === 'success') {
            const respnseData: { [key: string]: any } = data;
            setRjectInfo({
                documentDenialComment: respnseData['documentDenialComment'],
                memberValid: respnseData['memberValid'],
                profileImageValid: respnseData['profileImageValid'],
                rejectList: Object.keys(respnseData)
                    .filter((item) => respnseData[item] === false)
                    .map((item) => getDocRejectComment(item)),
            });
        } else {
            if (message) {
                alert(message);
                history.push(SERVICE_SELECT.path);
            }
        }
    }, [fetchResult, history]);

    const onClickApproveCheckCallback = useCallback(
        (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
            if (serviceType && serviceIdx) {
                apiServiceApproveChecked(serviceType, serviceIdx)
                    .then((response) => {
                        const { result, message } = response;

                        if (result === 'success') {
                            alert('최종승인 요청을 완료하였습니다.');
                            history.push(SERVICE_SELECT.url);
                        } else {
                            if (message) alert(message);
                        }
                    })
                    .catch((error) => {});
            }
        },
        [history, serviceIdx, serviceType]
    );

    const onClickProfileRegisterCheckCallback = useCallback(
        (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
            history.push(`${PROFILE_REGISTER.url}/${serviceType}/${serviceIdx}`);
        },
        [history, serviceIdx, serviceType]
    );

    const approveCheckProps = {
        documentDenialComment: rjectInfo.documentDenialComment,
        rjectInfoList: rjectInfo.rejectList,
        memberValid: rjectInfo.memberValid,
        profileImageValid: rjectInfo.profileImageValid,
        isActive: serviceType === 'smallmove' ? isProfile : isProfile,
        onClickApproveCheck: isProfile ? onClickApproveCheckCallback : () => {},
        buttons:
            serviceType === 'smallmove'
                ? [
                      {
                          name: '대표 프로필 만들기',
                          onClick: serviceDocStatus === 'approve_reject' ? onClickProfileRegisterCheckCallback : () => {},
                          checked: isProfile,
                      },
                  ]
                : [
                      {
                          name: '대표 프로필 만들기',
                          onClick: serviceDocStatus === 'approve_reject' ? onClickProfileRegisterCheckCallback : () => {},
                          checked: isProfile,
                      },
                      {
                          name: '직원 등록하기',
                          onClick:
                              serviceDocStatus === 'approve_reject'
                                  ? (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                                        if (isMember) {
                                            history.push(`${USER_LIST.url}/${serviceType}/${serviceIdx}`);
                                        } else {
                                            history.push(`${USER_REGISTER.url}/${serviceType}/${serviceIdx}`);
                                        }
                                    }
                                  : () => {},
                          checked: isMember,
                      },
                      {
                          name: '제공 서비스 등록하기',
                          onClick:
                              serviceDocStatus === 'approve_reject'
                                  ? (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
                                        history.push(`${SERVICE_FEATURE_REGISTER.url}/${serviceType}/${serviceIdx}`);
                                    }
                                  : () => {},
                          checked: isOffer,
                      },
                  ],
    };

    return (
        <Template>
            <ServiceApproveReject {...approveCheckProps} />
        </Template>
    );
}

export default ServiceApproveRejectView;
